/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { headerBreak } from '@/components/content/Header/styles/break';
import { SxProps, Theme } from '@mui/material';

export const headerNavBarContainerSX: SxProps = {
	borderRadius: 0,
	boxShadow: 0,
	display: headerBreak({ mobile: 'none', desktop: 'block' }),
	backgroundColor: 'transparent',
};

export const containerHeader: SxProps = {
	maxWidth: '100%',
	width: '100%',
	margin: '0 auto',
	padding: '0 30px',
};

export const containerHeaderCenter: SxProps<Theme> = (theme) => ({
	[theme.breakpoints.up('md')]: {
		maxWidth: '150px',
	},
	[theme.breakpoints.down('md')]: {
		maxWidth: '129px',
	},
});
